import $ from 'jquery'
import _ from 'underscore'
import robotSvg from 'components/people/AgentBadge/robotSvg'

const AGENT_BADGE_SVG = `<span class="agent-badge__icon">${robotSvg({bodyColor: '#888', accentColor: '#fff'})}</span>`

function triggerChange(e) {
  $(e.target).trigger('change')
}

function renderPersonItem(ul, item) {
  const badge = item.kind === 'agent'
    ? ` ${AGENT_BADGE_SVG}`
    : ''
  return $('<li>')
    .append(`<div>${$.fn.jquery ? $('<span>').text(item.label).html() : item.label}${badge}</div>`)
    .appendTo(ul)
}

_(gf).extend({
  setupAutocomplete() {
    $('[data-gf-autocomplete]').each(function () {
      const instance = $(this).autocomplete({
        source: $(this).data('gf-autocomplete'),
        appendTo: 'body',
        change: triggerChange,
        select: triggerChange,
      })
      // eslint-disable-next-line no-underscore-dangle
      instance.autocomplete('instance')._renderItem = renderPersonItem
    })
    $('[data-gf-triggered-autocomplete]').each(function () {
      $(this).triggeredAutocomplete({
        source: $(this).data('gf-triggered-autocomplete'),
        trigger: '@',
        appendTo: 'body',
        change: triggerChange,
        select: triggerChange,
      })
    })
    $('[data-gf-simple-triggered-autocomplete]').each(function () {
      $(this).triggeredAutocomplete({
        source: $(this).data('gf-simple-triggered-autocomplete'),
        trigger: '@',
        appendTo: 'body',
        change: triggerChange,
      })
    })
  },
})

$(document).ready(gf.setupAutocomplete)
  .on('dialogopen', gf.setupAutocomplete)
  .on('ajax:success', gf.setupAutocomplete)
